import Tree from 'antd/lib/tree'

import 'antd/lib/tree/style'

export * from 'antd/lib/tree'

export default Tree
